<template>
    <div class="mainContent statementsPage">
        <div class="transactionsWrap frameMobile">
            <div class="titleWrap mainPageTitle">
                <h2>Transactions</h2>
                <div class="buttonWrap" v-if="$mq=='sm'">
                    <button @click="showFilters = !showFilters" class="btnFilters">{{'pages/statements.button.filter' | trans }}</button>
                    <transition name="fade">
                        <TransactionFilters
                            v-if="showFilters"
                            v-on:setTransactionFilters="filterValue = $event"
                            v-bind:filterValue="filterValue"
                            v-on:modalToggle="showFilters=false"
                        />
                    </transition>
                </div>
            </div>

            <TransactionFilters
                v-if="$mq=='lg'"
                v-on:setTransactionFilters="filterValue = $event"
                v-on:setFiltersDate="filterByDate = $event"
                v-bind:filterValue="filterValue"
                :dates="filterDate()"
            />

            <div class="transactions">
                <transition-group name="fadeCustom" tag="div">
                    <transaction
                        v-for="transaction in displayTransactions()"
                        :key="transaction.id"
                        v-bind="transaction"
                    />
                </transition-group>
                <PulseLoader v-if="transactionsLoading" size="8px" color="#00B2FF"/>
            </div>
            <PulseLoader v-if="moreTransactionsLoading" size="8px" color="#00B2FF"
                         class="loadMore center"/>
            <div v-else class="loadMore center">
                <div v-if="displayShowMoreButton">
                    <button
                        :disabled="transactionsLoading ? true : false"
                        @click="showMoreTransactions"
                        class="btnSec"
                    >
						{{'pages/statements.button.show-more-transactions' | trans }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {mapState, mapGetters, mapActions} from 'vuex';
    import Transaction from '../components/Transactions/Transaction';
    import TransactionFilters from '../components/Transactions/TransactionFilters';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import moment from 'moment';
    import region from "../mixins/region";

    export default {

        data() {
            return {
                transactionsAll: [],
                transactionsFiltered: [],
                filterValue: 'other', //Debits/Credits/Others
                filterByDate: '', //Date filters
                showFilters: false, //mobile
                start: 0,
                end: 5,
                transactionLoadLimit: 5,
                moreTransactionsLoading: false,
                loadDuration: 500,
                displayShowMoreButton: true,
            }
        },
        mixins:[region],
        components: {Transaction, TransactionFilters, PulseLoader},
        mounted() {
            if (!this.transactions.length) {
                this.$store.dispatch('getTransactions');
            }

            this.transactionsAll = this.getTransactions;
        },
        methods: {
            ...mapActions(['addMessage', 'loadMoreTransactions']),
            showMoreTransactions: function () {
                this.moreTransactionsLoading = true;
                setTimeout(() => {
                    this.end += this.transactionLoadLimit;
                }, this.loadDuration);


                if (this.filterValue !== 'other') {
                    this.filterTransactionsByType(this.filterValue);

                }
                if (this.filterByDate) {
                    this.filterTransactionsByDate(this.filterByDate);
                }

            },
            filterTransactionsByType: function (type) {
                //if Show More button was clicked
                let transactions = this.moreTransactionsLoading ? this.transactionsAll : this.transactionsLimit(this.transactionsAll);

                const filtered = transactions.filter(t => {
                    if (this.filterByDate) {
                        if(type === 'other'){
                            return this.dateFormat(t.date) === this.filterByDate;
                        } else {
                            return t.type === type && this.dateFormat(t.date) === this.filterByDate;
                        }
                    }
                    return t.type === type
                });

                return this.transactionsFiltered = filtered.length > this.end ? this.transactionsLimit(filtered) : filtered;

            },
            filterTransactionsByDate: function (date) {
                let transactions = this.moreTransactionsLoading ? this.transactionsAll : this.transactionsLimit(this.transactionsAll);
                const filtered = transactions.filter(t => {

                    const formatDate = this.dateFormat(t.date);

                    if(this.filterValue === 'other'){
                        return formatDate === date;
                    }

                    if (this.filterValue) {
                        return formatDate === date && t.type === this.filterValue;
                    }

                    return formatDate === date;
                });

                return this.transactionsFiltered = filtered.length > this.end ? this.transactionsLimit(filtered) : filtered;
            },
            displayTransactions: function () {

                if (this.transactionsFiltered.length) {
                    return this.transactionsFiltered;
                }

                return this.transactionsLimit(this.transactionsAll);

            },
            filterDate: function () {
                const dates = this.transactionsFiltered.length ? this.transactionsFiltered : this.transactionsLimit(this.transactionsAll);
                const filteredDates = dates.map(d => this.dateFormat(d.date));
                //remove duplicates
                const unique = [...new Set(filteredDates)];
                return unique;
            },
            dateFormat: function (date) {
                if (this.getRegionId() === 'us') {
                    return moment(date, 'MM/DD/YYYY').format('YYYY MMMM');
                }
                return moment(date, 'DD.MM.YYYY').format('YYYY MMMM');
            },
            transactionsLimit: function(transactions) {
                return transactions.slice(this.start, this.end);
            }
        },
        computed: {
            ...mapState(['transactionsLoading', 'transactionsShowMore', 'transactions']),
            ...mapGetters(['getTransactions']),
        },
        watch: {
            filterValue: function (type) {
                this.filterTransactionsByType(type);
                //hide filters on mobile when selected
                if (type) {
                    this.showFilters = false;
                }
            },
            filterByDate: function (date) {
                if (date) {
                    this.filterTransactionsByDate(date);
                }
                if (!date && this.filterValue) {
                    this.filterTransactionsByType(this.filterValue);
                }
                if (!date && !this.filterValue) {
                    this.transactionsFiltered = [];
                    return this.getTransactions;
                }
            },
            end: function () {
                this.displayShowMoreButton = this.transactions.length > this.end;
                this.moreTransactionsLoading = false;
            },
            transactions: function () {
                this.end = this.end * 1;
            },
        }
    }
</script>
